/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};
  Shopify.theme.jsImageWithText = {
    init: function ($section) {

  
      $(document).on('scroll', function(){
        $section.each(function() {
            var sectionTop = $section.offset().top - 600;
            var sectionBottom = $section.offset().top;
            var windowHeight = $(window).height();
            var scrollPosition = $(document).scrollTop();
            var triggerPosition = $section.find('.image-with-text__text-column').offset().top;

            var top_left_position = parseInt($section.find('.image-text-tl').data('top-left-position'));
            var top_right_position = parseInt($section.find('.image-text-tr').data('top-right-position'));
            var bottom_left_position = parseInt($section.find('.image-text-bl').data('bottom-left-position'));
            var bottom_right_position = parseInt($section.find('.image-text-br').data('bottom-right-position'));
            
            // Check if the section is in view
            if (scrollPosition >= sectionTop - windowHeight && scrollPosition < sectionTop + $section.outerHeight()) {
                var sectionHeight = $section.outerHeight();
                var distanceFromTop = scrollPosition - sectionTop;
    
                // Apply the scroll effect only when the section is in view
                $section.find('.image-text-tl').css("top", Math.max(windowHeight - distanceFromTop - 300, top_left_position) + "px");
                $section.find('.image-text-tr').css("top", Math.max(windowHeight - distanceFromTop - 300, top_right_position) + "px");                      
            }

            // Check if the scroll position passes the trigger position
            if (scrollPosition >= triggerPosition) {
                var distanceFromBottom = scrollPosition - triggerPosition;
                var imageBottomLeft;
                var imageBottomRight;
      
                if (distanceFromBottom <= 400) {                    
                    imageBottomLeft = -500 + (310 / 400) * distanceFromBottom;
                    imageBottomRight = -500 + (250 / 400) * distanceFromBottom;
                } else {
                    // Set the final position of the last image to bottom: -190px
                    imageBottomLeft = bottom_left_position;
                    imageBottomRight = bottom_right_position;
                }

                $section.find('.image-text-bl').css({
                    "bottom": imageBottomLeft + "px",
                    "opacity": 1
                });
                $section.find('.image-text-br').css({
                    "bottom": imageBottomLeft + "px",
                    "opacity": 1
                });
            }

          
        });        
    });



      $(document).on('scroll', function(){
        $section.each(function() {
           var sectionTopMob = $section.offset().top - 400;
        var windowHeightMob = $(window).height();
        var scrollPositionMob = $(document).scrollTop();
        var triggerPositionMob = $section.find('.image-with-text__text-column').offset().top;

        var top_left_m_position = parseInt($section.find('.image-text-m-tl').data('top-left-mob-position'));
        var top_right_m_position = parseInt($section.find('.image-text-m-tr').data('top-right-mob-position'));
        var bottom_left_m_position = parseInt($section.find('.image-text-m-bl').data('bottom-left-mob-position'));
        var bottom_right_m_position = parseInt($section.find('.image-text-m-br').data('bottom-right-mob-position'));

        // Check if the section is in view
        if (scrollPositionMob >= sectionTopMob - windowHeightMob && scrollPositionMob < sectionTopMob + $section.outerHeight()) {
            var sectionHeightMob = $section.outerHeight();
            var distanceFromTopMob = scrollPositionMob - sectionTopMob;

            // Apply the scroll effect only when the section is in view
            $section.find('.image-text-m-tl').css("top", Math.max(windowHeightMob - distanceFromTopMob - 400, top_left_m_position) + "px");
            $section.find('.image-text-m-tr').css("top", Math.max(windowHeightMob - distanceFromTopMob - 400, top_right_m_position) + "px");
        }

        // Check if the scroll position passes the trigger position
        if (scrollPositionMob >= triggerPositionMob) {
            var distanceFromBottomMob = scrollPositionMob - triggerPositionMob;
            var imageBottomLeftMob;
            var imageBottomRightMob;

            if (distanceFromBottomMob <= 700) {
                imageBottomLeftMob = -300 + (310 / 300) * distanceFromBottomMob;
                imageBottomRightMob = -300 + (250 / 300) * distanceFromBottomMob;
            } else {
                // Set the final position of the last image to bottom: -190px
                imageBottomLeftMob = bottom_left_m_position;
                imageBottomRightMob = bottom_right_m_position;
            }

            $section.find('.image-text-m-bl').css({
                "bottom": imageBottomLeftMob + "px",
                "opacity": 1
            });
            $section.find('.image-text-m-br').css({
                "bottom": imageBottomLeftMob + "px", // Should it be imageBottomRightMob here?
                "opacity": 1
            });
        }

          
        });        
    });





    },
    unload: function ($section) {}
  }

  /******/
})()
  ;